import angular from 'angular';

angular
  .module('cxInvoicing')
  .controller('DraftInvoiceLineDialogCtrl', [
    '$element',
    '$scope',
    'dataCache',
    'resourceFactorySvc',
    'flySvc',
    'enumCacheSvc',
    'close',
    'invoice',
    '$filter',
    'priceService',
    'resourceNameFilter',
    draftInvoiceLineDialogCtrl,
  ]);

function draftInvoiceLineDialogCtrl(
  $element,
  $scope,
  dataCache,
  resourceFactorySvc,
  flySvc,
  enumCacheSvc,
  close,
  invoice,
  $filter,
  priceService,
  resourceNameFilter,
) {
  var vm = this;
  vm.resourceTypes = [];
  vm.loading = 2;
  enumCacheSvc.get('resourceType').then(function(data) {
    vm.resourceTypes = data.filter(x => x.key !== 3 && x.key !== 4 && x.key !== 5);
    vm.loading--;
  });
  vm.currentUser = dataCache.getArray('employee');
  vm.invoice = invoice;

  vm.invoiceStreams = (invoice.customer?.invoiceStreams || []).filter(
    x =>
      (x.isActive || x.id === invoice.invoiceStreamId) &&
      (x.companyId ?? invoice.customer.companyId) === invoice.companyId &&
      (!invoice.invoiceLines || invoice.invoiceLines.some(l => l.invoiceStreamId === x.id)),
  );

  vm.lineType = null;
  vm.line = {
    quantity: 1,
    vatRate: dataCache.getDefaultCompany().resourceVATRate,
    vatType: 0,
    discountPercentage: 0,
    invoiceStreamId: invoice.invoiceStreamId,
    ledger: dataCache.getCompanySettings(vm.invoice.companyId)
      .onlyUseDefaultLedgerForNewPriceListItems
      ? null
      : dataCache.getCompanySettings(vm.invoice.companyId).resourceLedgerAccount,
  };

  //If false, a billing registration will be created, otherwise it's only an invoice line
  vm.isFreeInvoice =
    vm.invoice.invoiceType === 5 || //Free Invoice
    vm.invoice.invoiceType === 6 || //Intra company invoice
    (vm.invoice.invoiceType === 2 && !vm.invoice.hasRegistrations()) || //Advance without registrations
    !!vm.invoice.status; //Numbered invoice
  vm.showValidation = false;
  vm.price = null;

  resourceFactorySvc.get('resource').reg({}, function(data) {
    var resources = data
      .filter(x => x.type !== 3 && x.type !== 4)
      .map(item => ({ ...item, label: resourceNameFilter(item), code: item.code || '' }));
    vm.resources = resources.reduce(function(a, e) {
      if (!a[e.type]) a[e.type] = [];
      a[e.type].push(e);
      return a;
    }, {});
    vm.loading--;
  });
  if (!vm.invoice.isInvoice) {
    vm.line.quantity = -1;
  }

  vm.validate = function() {
    if ($scope.form && $scope.form.$invalid) {
      return false;
    }
    if (vm.lineType == null) return false;
    if (
      (vm.lineType == -3 || vm.lineType == -5 || vm.lineType == -4 || vm.lineType == -7) &&
      !vm.line.resource
    )
      return false;
    if (vm.lineType >= 0 && !vm.resource) return false;
    if (vm.lineType >= 0 && vm.resource.isOther && !vm.resource) return false;
    if (vm.line.quantity == null && vm.lineType != -7) return false;
    if (vm.line.unitPrice == null && vm.lineType != -7) return false;
    if (vm.line.vatRate == null && vm.lineType != -7) return false;
    return true;
  };
  vm.lineTypeChanged = function() {
    const { companyId } = vm.invoice;

    vm.resource = null;
    vm.line.resource = null;
    vm.line.ledger = dataCache.getCompanySettings(companyId)
      .onlyUseDefaultLedgerForNewPriceListItems
      ? null
      : dataCache.getCompanySettings(companyId).resourceLedgerAccount;
    vm.line.resourceCode = null;
    vm.line.quantity = !vm.line.quantity && !(vm.line.quantity < 0) ? 1 : vm.line.quantity;
    vm.line.unitPrice = null;
    vm.line.vatRate = null;
    vm.line.vatType = null;
    vm.line.billable = true;
    vm.line.price = null;
    vm.line.discountPercentage = 0;
    vm.price = null;
    vm.line.type = vm.lineType;
    vm.priceOptions = null;

    if (vm.lineType == -5) {
      vm.line.quantity = 1; //Advances are always positive
      vm.line.ledger = dataCache.getCompanySettings(companyId).advanceSettlementLedgerAccount;
    } else {
      if (!vm.invoice.isInvoice) {
        //Set quantity to negative because it is a credit note
        vm.line.quantity = Math.abs(vm.line.quantity) * -1;
      } else {
        //Set quantity to positive because it is an invoice
        vm.line.quantity = Math.abs(vm.line.quantity);
      }
    }
    if (vm.lineType < 0) {
      // 'LineType' in front-end does not match with the enum in backend since front-end also contains 'Resource types'
      // If the linetype is negative, get the absolute value so it matches with the back-end line type enum

      const invoiceLineType = Math.abs(vm.lineType);
      vm.line.type = invoiceLineType;

      vm.line.vatRate = dataCache.getDefaultCompany().resourceVATRate;
      vm.line.vatType = 0;
    }
  };
  vm.resourceChanged = function() {
    if (!vm.resource) return;
    vm.line.unitPrice = 0;
    vm.line.price = null;
    vm.line.ledger = vm.resource.ledger;
    if (
      !vm.line.ledger &&
      !dataCache.getCompanySettings(vm.invoice.companyId).onlyUseDefaultLedgerForNewPriceListItems
    ) {
      vm.line.ledger = dataCache.getCompanySettings(vm.invoice.companyId).resourceLedgerAccount;
    }
    vm.price = null;
    vm.line.vatRate = vm.resource.vatPercentage;
    vm.line.vatType = vm.resource.vatType;
    if (!vm.isFreeInvoice) vm.line.billable = vm.resource.isBillable;

    vm.priceOptions = null;
    priceService
      .getPrice({
        category: vm.resource.categoryId,
        invoiceStream: vm.line.invoiceStreamId,
        user: vm.currentUser.userID,
      })
      .then(function(price) {
        if (price) {
          vm.priceOptions = [price];
          vm.price = price;
        }
      });
  };
  vm.unitPriceChanged = function() {
    vm.line.price = null;
    vm.price = null;
  };

  vm.selectPrice = function(price) {
    vm.line.price = price;
    if (price) vm.line.unitPrice = price.amount;
  };

  $scope.$watch('vm.price', vm.selectPrice);

  vm.saving = false;
  vm.save = function() {
    if (vm.saving) return;
    if (!vm.validate()) return;
    vm.saving = true;
    if (vm.lineType < 0 || vm.isFreeInvoice) {
      if (!vm.line.resource) {
        vm.line.resource = resourceNameFilter(vm.resource, true);
        vm.line.resourceCode = vm.resource.code;
      }
      if (vm.resource) {
        vm.line.resourceCategoryId = vm.resource.categoryId;
      }
      resourceFactorySvc.get('invoiceLine').save(
        {
          id: vm.invoice.id,
        },
        vm.line,
        function(result) {
          result.resultType = 0;
          $element.modal('hide');
          close(result, 500);
          flySvc.success('Line added');
          vm.saving = false;
        },
        function(error) {
          flySvc.error(error.data.code, error.data.parameters);
          vm.saving = false;
        },
      );
    } else {
      if (!vm.resource.isOther) {
        vm.line.resource = null;
        vm.line.resourceCode = null;
      }

      resourceFactorySvc.get('invoiceRegistration').create(
        {
          invoiceId: vm.invoice.id,
        },
        angular.extend(vm.line, {
          resourceId: vm.resource.id,
          type: vm.lineType,
          userId: vm.currentUser.userID,
          date: new Date(),
        }),
        function(result) {
          result.resultType = 1;
          $element.modal('hide');
          close(result, 500);
          flySvc.success('Line added');
          vm.saving = false;
        },
        function(error) {
          flySvc.error(error.data.code, error.data.parameters);
          vm.saving = false;
        },
      );
    }
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
